import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { publish } from 'rxjs-compat/operator/publish';
import { BookmarkTemplateService } from '../../../services/bookmark-template.service';
import { Bookmark } from '../../../models/bookmakmodel';
import { DocumentTemplate } from '../../../models/document-template.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { element } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-bookmarks-dialog',
  template: require('./bookmarks-dialog.component.html'),
  styles: [require('./bookmarks-dialog.component.css')]
})
export class BookmarksDialogComponent implements OnInit {
    isLoading = false;
    bookmarks: Bookmark[] = [];
    test: string = "";
    currentDocumentTemplate: DocumentTemplate;
    isGlobal: boolean = false;
    applicantForm: FormGroup = new FormGroup({});
    bookmarkFrom: FormGroup = new FormGroup({});
    isCreate = false;
    newBookmark: Bookmark;
    isChange: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<BookmarksDialogComponent>,
        private bookmarkTemplateService: BookmarkTemplateService,
        private fb: FormBuilder
    ) {
        this.currentDocumentTemplate = this.data;
        this.newBookmark = {} as Bookmark;
        console.log(data)
        if (this.currentDocumentTemplate.name.indexOf('Global')) {
            this.isGlobal = true;
        }
    }

    ngOnInit() {
        //template form
        this.applicantForm = this.fb.group({
            name: ["", Validators.required],
            documentTemplatePath: [""],
            documentType: ['', Validators.required],
            emailSubject: [''],
            emailtemplatePath: [''],
            documentBookmarksJson: [''],
            emailBookmarksJson: [''],
        })

        //bookmark form
        this.bookmarkFrom = this.fb.group({
            bookmark: ["", [Validators.required, Validators.maxLength(100)]],
            bookmarkPathValue: ["", [Validators.required]],
        })

        if (this.currentDocumentTemplate.documentTemplateId) {
            this.bookmarks = this.currentDocumentTemplate.documentTemplateBookmarks;
        } else {
            this.getBookmarskGlobal()
        }
    }

    getBookmarskGlobal() {
        this.bookmarks = [];
        this.isLoading = true;
        this.bookmarkTemplateService.getGlobalBookmarks().subscribe(r => {
            this.bookmarks = r;
            this.isLoading = false;
        } )
    }

    close() {
        this.dialogRef.close(this.isChange);
    }

    updateAllBookmark() {
        this.bookmarkTemplateService.updateAllBookmark(this.bookmarks).subscribe(r => {
            if (r && this.currentDocumentTemplate.documentTemplateId) {
                this.getDocumentTemplate(this.currentDocumentTemplate.documentTemplateId);
            } else {
                this.getBookmarskGlobal();
            }
        })
    }

    updateBookmark(bookmark: Bookmark) {
        this.isChange = true;
        this.bookmarkTemplateService.updateBookmark(bookmark).subscribe(r => {
            if (r && this.currentDocumentTemplate.documentTemplateId) {
                this.getDocumentTemplate(this.currentDocumentTemplate.documentTemplateId);
            } else {
                this.getBookmarskGlobal();
            }
        })
        
    }

    getDocumentTemplate(templateId) {
        this.bookmarks = [];
        this.currentDocumentTemplate = {} as any;
        this.isLoading = true;
        this.bookmarkTemplateService.getTemplateById(templateId).subscribe(cd => {
            this.currentDocumentTemplate = cd;
            this.bookmarks = this.currentDocumentTemplate.documentTemplateBookmarks;
            this.isLoading = false;
        })
    }

    updateTemplate() {
        console.log(this.applicantForm.value)
        if (!this.applicantForm.valid) {
            return
        } else {
            this.bookmarkTemplateService.updateDocumentTemplate(this.currentDocumentTemplate).subscribe(r => {
                if (r) {
                    this.isChange = true;
                    this.getDocumentTemplate(this.currentDocumentTemplate.documentTemplateId);
                }
            } )
        }
    }

    createBookmark() { 
        console.log(this.bookmarkFrom.valid)
        this.isChange = true;
        if (this.bookmarkFrom.valid) {
            this.isCreate = false;
            //console.log(this.bookmarkFrom.value);
            this.bookmarkTemplateService.createBookmark(this.bookmarkFrom.value, this.currentDocumentTemplate.documentTemplateId).subscribe(r => {
                if (this.currentDocumentTemplate.documentTemplateId) {
                    this.getDocumentTemplate(this.currentDocumentTemplate.documentTemplateId);
                } else {
                    this.getBookmarskGlobal();
                }
            })
        } else {
            Object.keys(this.bookmarkFrom.controls).forEach(b => {
                this.bookmarkFrom.controls[b].markAsTouched()
            })
            return;
        }

    }

    onDeleteBookMark(bookmark: Bookmark) {
        console.log(bookmark)
        this.bookmarkTemplateService.deleteBookmark(bookmark).subscribe(r => {
            if (r && this.currentDocumentTemplate.documentTemplateId) {
                this.getDocumentTemplate(this.currentDocumentTemplate.documentTemplateId);
            } else {
                this.getBookmarskGlobal();
            }
        })
    }



}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/bookmark-templates/bookmarks-dialog/bookmarks-dialog.component.ts